export default __webpack_public_path__ + "static/DontMissOutAnyLeads-9160ae931e38803ef39539e37d7dcb11.svg";